import React, { useState, useEffect } from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import Error from '../Shared/Error.js'
import ItemDetailsPane from './ItemDetailsPane.js'
import AddItemPopup from './AddItemPopup.js'
import LoadingSpinnerImage from '../Shared/LoadingSpinnerImage.js'

const ProductFamilies = () => {

    const [isLoadingStructure, setIsLoadingStructure] = useState(true);
    const [errorLoadingStructure, setErrorLoadingStructure] = useState(false);
    const [dataTableStructure, setDataTableStructure] = useState({});

    let config = {};

    config.dataUrl = "/umbraco/api/RIMSProducts/ProductFamilies";
    config.getSingleItemUrl = "/umbraco/api/RIMSProducts/ProductFamily";
    config.pageTitle = "Product Families";
    config.singleItemTitle = "Product Family";
    config.entityType = "product-family";
    config.entityTypeId = 1; // product-families
    config.pageIcon = "fas fa-layer-group";
    config.breadcrumbs = [{ "Name": "Products", "Link": "/your-medboard/products/" }, { "Name": "Product Families", "Link": "/your-medboard/product-families/" }]
    config.dataStructure = [];
    config.exportUrl = "/umbraco/api/RIMSProducts/ProductFamiliesExport/?familyIds=";
    config.deleteUrl = "/umbraco/api/RIMSProducts/BulkProductFamilies/?familyIds=";
    //config.enableTags = true;
    //config.currentLegalManufacturerFilter = window.legalManufacturerId;
    //config.currentLegalManufacturerNameFilter = window.legalManufacturerName;
    config.enableCustomFields = true;
    config.showExportButton = true;
    config.showDeleteButton = true;
    
    config.productStandardsListItemUrl = window.productStandardsListItemUrl;
    config.productRegulatoryDocumentsListItemUrl = window.productRegulatoryDocumentsListItemUrl;
    config.productReferenceManagerListItemUrl = window.productReferenceManagerListItemUrl;
    config.preLoadItemUrlParamName = "Id";
    //config.productsConfigurationsUrl = "/umbraco/api/RIMSProducts/ConfigurableDevices/?productId=";
    //config.productsLiteratureUrl = "/umbraco/api/RIMSProducts/Literature/?id=";
    //config.productsArchiveUrl = "/umbraco/api/RIMSProducts/Products/?id=";
    config.excelExportFileName = "MedBoardProductFamiliesExport";
    //config.productFamilyUrl = window.familyUrl;
    //config.productRegistrationsCountUrl = window.registrationsUrl;
    config.preLoadItemId = window.preloadFamilyId;

    config.showListTotalCount = true;
    config.listTotalCountURL = "/umbraco/api/RIMSProducts/ProductFamiliesCount/";
    config.showTaskCount = true;



    useEffect(() => {

        loadStructure();

    }, []);


    const loadStructure = () => {

        setIsLoadingStructure(true);
        setErrorLoadingStructure(false);

        let tableHeaderUrl = "/umbraco/api/CustomFields/Headers/?entityType=" + config.entityTypeId;

        let requestOptions = {
            method: 'GET',
        };

        fetch(tableHeaderUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    setHasMoreData(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                result.map(column => {
                    config.dataStructure.push({
                        customFieldId: column.CustomFieldId,
                        customFieldType: column.CustomFieldType,
                        name: column.Name,
                        field: column.Field,
                        width: column.Width,
                        sortable: column.Sortable,
                        isSelectItemCheckbox: column.IsSelectItemCheckbox,
                        renderWith: FieldTypes[column.RenderWith] ?? FieldTypes.FieldType_Text,
                        isMultiField: column.IsMultiField,
                        disableRowClick: column.DisableRowClick,
                    });
                });

                setDataTableStructure(config);
                setIsLoadingStructure(false);
            })
            .catch((error) => {
                setErrorLoadingStructure(true);
            })
            .finally(() => {
            });
    }

    
    return (<>

        {errorLoadingStructure ? <>
            <Error message={"Failed to load table configuration"} />
        </> : <>
                {isLoadingStructure ? <>
                    <LoadingSpinnerImage />
                </> : <>
                        <DataTable dataTableStructure={dataTableStructure}
                            ItemDetailsPane={ItemDetailsPane}
                            AddItemPopup={AddItemPopup}
                            ReloadStructureFunction={loadStructure} />
                </>}

        </>}


    </>);

};






export default ProductFamilies;